import styles from './StepSlider.module.css';
import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";

export default function StepSlider({ 
  min = 1, 
  max = 20, 
  value, 
  onChange 
}) {
  const svgRef = useRef(null);
  const containerRef = useRef(null);
  const [svgWidth, setSvgWidth] = useState(0);
  const [thumbX,setThumbX]=useState(270);
  const [tempValue,setTempValue]=useState(value);

  const height = 20;
  const trackHeight = 4;
  const thumbRadius = 8;

  useEffect(() => {
    const resize = () => {
      if (containerRef.current) {
        setSvgWidth(containerRef.current.offsetWidth);
      }
    };
    resize();

    const observer = new ResizeObserver(resize);
    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (svgWidth === 0) return;

    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove();

    const scale = d3.scaleLinear().domain([min, max]).range([thumbRadius, svgWidth - thumbRadius]);
    const step = 1;
    const steps = [1,5,10,15,20];

    svg
      .append("line")
      .attr("x1", scale(min))
      .attr("x2", scale(max))
      .attr("y1", height / 2)
      .attr("y2", height / 2)
      .attr("stroke", 'var(--color-border')
      .attr("stroke-width", trackHeight)
      .attr("stroke-linecap", "round");

    svg
      .selectAll(".mark")
      .data(steps)
      .enter()
      .append("line")
      .attr("x1", d => scale(d))
      .attr("x2", d => scale(d))
      .attr("y1", height / 2 - 6)
      .attr("y2", height / 2 + 6)
      .attr("stroke", 'var(--color-border)')
      .attr("stroke-linecap", "round")
      .attr("stroke-width", 2);

    svg
      .selectAll(".label")
      .data(steps)
      .enter()
      .append("text")
      .text(d => d)
      .attr("x", d => scale(d))
      .attr("y", height / 2 + 28)
      .attr("text-anchor", "middle")
      .attr("font-size", "12px")
      .attr("fill", 'var(--color-border');

    const thumb = svg
      .append("circle")
      .attr("r", thumbRadius)
      .attr('stroke', 'var(--color-text')
      .attr('stroke-width', 2)
      .attr("cx", scale(value))
      .attr("cy", height / 2)
      .attr("fill", "var(--color-light)")
      .style("cursor", "pointer")
      .call(
        d3
          .drag()
          .on("drag", (event) => {
            const pos = Math.max(thumbRadius, Math.min(svgWidth - thumbRadius, event.x));
            const newVal = Math.round(scale.invert(pos) / step) * step;
            const clamped = Math.min(max, Math.max(min, Math.round(newVal)));

            thumb.attr("cx", scale(clamped));
            setThumbX(scale(clamped));
            setTempValue(clamped);
          })
          .on("end",(event)=>{
            const pos = Math.max(thumbRadius, Math.min(svgWidth - thumbRadius, event.x));
            const newVal = Math.round(scale.invert(pos) / step) * step;
            const clamped = Math.min(max, Math.max(min, Math.round(newVal)));
            onChange(clamped);
          })
      );
  }, [svgWidth, min, max, value, onChange]);

  return (
    <div ref={containerRef} className={styles['wrap']}>
      <svg 
      ref={svgRef} 
      width={svgWidth} 
      height={height}
      />
      <div 
      className={styles['bubble']}
      style={{
        left:`${thumbX}px`,
      }}
      >
        {tempValue}
      </div>
    </div>
  );
}